<script>
import {
  required,
} from "vuelidate/lib/validators";
import { notify } from '@/helpers/notify' 
import Loader from "./../../../../components/widgets/loader.vue";

export default {
    components: {
        Loader,
    },
    page: {
        title: "SMS İşlemleri",
    },
    data() {
        return {
            form: {},
            dataLoading:true,
            submitted:false,
        };
    },
    validations: {
        form:{
            username: { required },
            password: { required },
            orginator: { required },
        }
    },
    mounted() {
        this.getList()
    },
    methods: {
        getList(){
            this.$http.get('/integrations/sms')
            .then(resp => {
                this.form = resp.data
                this.dataLoading=false
            })
           
        },
        handleSubmit() {
            this.submitted = true;
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            } else {
                this.$http.put('/integrations/sms', { ...this.form})
                .then(resp => {
                    notify.success(resp.data.message)
                }) .catch(error => error)
            }
            this.submitted = false;
        },
    }
};
</script>

<template>
<Loader :loading="true" :load="dataLoading">
    <div class="d-flex justify-content-start">
        <div class="col-6">
            <div class="card">
                <div class="card-body">
                    <form class="needs-validation" @submit.prevent="handleSubmit">
                    <div class="row">
                        <div class="md-6">
                            <b-form-group
                                class="mb-3"
                                label="Üye No(Yoksa Boş Geçiniz)"
                                label-cols-sm="5"
                            >
                                <b-form-input
                                    v-model="form.code"
                                    type="text"
                                    placeholder="Üye No(Yoksa Boş Geçiniz)"
                                ></b-form-input>
                            </b-form-group>
                            <b-form-group
                                class="mb-3"
                                label="Kullanıcı Adı"
                                label-cols-sm="5"
                                >
                                <b-form-input
                                    v-model="form.username"
                                    type="text"
                                    placeholder="Üye No(Yoksa Boş Geçiniz)"
                                    :class="{
                                        'is-invalid': submitted && $v.form.username.$error,
                                    }"
                                >
                                </b-form-input>
                                <div
                                    v-if="submitted && $v.form.username.$error"
                                    class="invalid-feedback"
                                    >
                                    <span v-if="!$v.form.username.required">Bu alan zorunludur.</span>
                                </div>
                            </b-form-group>
                            <b-form-group
                                class="mb-3"
                                label="Şifre"
                                label-cols-sm="5"
                                >
                                <b-form-input
                                    v-model="form.password"
                                    type="text"
                                    placeholder="Şifre"
                                    :class="{
                                        'is-invalid': submitted && $v.form.password.$error,
                                    }"
                                >
                                </b-form-input>
                                <div
                                    v-if="submitted && $v.form.password.$error"
                                    class="invalid-feedback"
                                    >
                                    <span v-if="!$v.form.password.required">Bu alan zorunludur.</span>
                                </div>
                            </b-form-group>
                            <b-form-group
                                class="mb-3"
                                label="Orginatör İsmi"
                                label-cols-sm="5"
                                >
                                <b-form-input
                                    v-model="form.orginator"
                                    type="text"
                                    placeholder="Orginatör İsmi"
                                    :class="{
                                        'is-invalid': submitted && $v.form.orginator.$error,
                                    }"
                                >
                                </b-form-input>
                                <div
                                    v-if="submitted && $v.form.orginator.$error"
                                    class="invalid-feedback"
                                    >
                                    <span v-if="!$v.form.orginator.required">Bu alan zorunludur.</span>
                                </div>
                            </b-form-group>
                            </div>
                            <div class="col-md-12">
                                <div class="mb-3 d-flex justify-content-end">
                                    <button class="btn btn-warning" type="submit">Güncelle</button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</Loader>
</template>